module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/481404389cb14208aa737d7d3db30675.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_expand_dark.svg
// module id = NaYz
// module chunks = 0